const storage = {
	get(key) {
		try {
			const data = localStorage.getItem(key)

			return JSON.parse(atob(data))
		} catch(error) {
			console.log(error)
			return null
		}
	},
	set(key, data) {
		try {
			const encodedData = btoa(JSON.stringify(data))

			localStorage.setItem(key, encodedData)

			return true
		} catch(error) {
			console.log(error)
			return false
		}
	},
	delete(key) {
		localStorage.removeItem(key)
	}
}

export default storage